import { useState } from 'react';
import { LeadTypeViewHeader } from '@components/LeadTypeViewHeader';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const LeadTypeHeaderSection = () => {
  const [leadNavIndex, setLeadNavIndex] = useState(3);

  return (
    <section className={styles.section}>
      <SectionHeader
        title="Lead Type View Header"
        description="Detailed header showing lead type info with interactive popover."
        figmaNodeId="137-1432"
        styles={styles}
      />

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Default</h3>
        <div className={styles.leadTypeHeaderBox}>
          <LeadTypeViewHeader
            title="Dental Clinic"
            slug="dental-clinic"
            date="Updated 15 Dec 12:34 PM"
            totalLeads={187}
            websiteObjectives={[
              'Attract and acquire new local patients',
              'Enable 24/7 online appointment scheduling',
              'Showcase services to build credibility and trust',
            ]}
            industryPainpoints={[
              'High volume of administrative phone calls',
              'Frequent patient no-shows and last-minute cancellations',
              'Lack of patient education and treatment understanding',
            ]}
          />
        </div>
        <p className={styles.hint}>Hover over the chip to see the popover.</p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>With Open In New Button</h3>
        <div className={styles.leadTypeHeaderBox}>
          <LeadTypeViewHeader
            title="Dental Clinic"
            slug="dental-clinic"
            date="Updated 15 Dec 12:34 PM"
            totalLeads={187}
            showOpenInNew
            onOpenInNew={() => alert('Open in new window clicked!')}
          />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Long Title (Truncation)</h3>
        <div className={styles.leadTypeHeaderBox}>
          <LeadTypeViewHeader
            title="Professional Medical Equipment and Healthcare Supply Distribution Services for Hospitals and Clinics"
            slug="medical-equipment-healthcare-supply-distribution"
            date="Updated 15 Dec 12:34 PM"
            totalLeads={187}
            showOpenInNew
            onOpenInNew={() => alert('Open in new window clicked!')}
            websiteObjectives={[
              'Streamline B2B ordering process',
              'Provide detailed product specifications',
            ]}
            industryPainpoints={['Complex procurement workflows', 'Long sales cycles']}
          />
        </div>
        <p className={styles.hint}>
          Title truncates with ellipsis when it exceeds the available width.
        </p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>With Metadata (URLs + Platform)</h3>
        <div className={styles.leadTypeHeaderBox}>
          <LeadTypeViewHeader
            title="Dental Clinic"
            slug="dental-clinic"
            date="Updated 15 Dec 12:34 PM"
            totalLeads={187}
            showMetadata
            totalUrls={187}
            platform="magento"
          />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>With Navigation Buttons</h3>
        <div className={styles.leadTypeHeaderBox}>
          <LeadTypeViewHeader
            title="Dental Clinic"
            slug="dental-clinic"
            date="Updated 15 Dec 12:34 PM"
            totalLeads={187}
            showNavButtons
            currentIndex={leadNavIndex}
            totalCount={10}
            onPrevious={() => setLeadNavIndex((prev) => Math.max(1, prev - 1))}
            onNext={() => setLeadNavIndex((prev) => Math.min(10, prev + 1))}
          />
        </div>
        <p className={styles.hint}>
          Current: <strong>{leadNavIndex}</strong> of 10 (Previous disabled at 1, Next disabled at
          10)
        </p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>With Edit Button</h3>
        <div className={styles.leadTypeHeaderBox}>
          <LeadTypeViewHeader
            title="Dental Clinic"
            slug="dental-clinic"
            date="Updated 15 Dec 12:34 PM"
            totalLeads={187}
            showEditButton
            onEdit={() => alert('Edit metadata clicked!')}
          />
        </div>
        <p className={styles.hint}>Edit button appears next to the metadata chip.</p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>With Edit + Delete Buttons</h3>
        <div className={styles.leadTypeHeaderBox}>
          <LeadTypeViewHeader
            title="Dental Clinic"
            slug="dental-clinic"
            date="Updated 15 Dec 12:34 PM"
            totalLeads={187}
            showEditButton
            onEdit={() => alert('Edit metadata clicked!')}
            showDeleteButton
            onDelete={() => alert('Delete business type clicked!')}
          />
        </div>
        <p className={styles.hint}>Edit and delete buttons appear next to the metadata chip.</p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Full Featured (All Props)</h3>
        <div className={styles.leadTypeHeaderBox}>
          <LeadTypeViewHeader
            title="E-commerce Store"
            slug="ecommerce-store"
            date="Updated 10 Jan 09:15 AM"
            totalLeads={342}
            showOpenInNew
            onOpenInNew={() => alert('Open in new window clicked!')}
            showMetadata
            totalUrls={342}
            platform="shopify"
            showNavButtons
            currentIndex={5}
            totalCount={15}
            onPrevious={() => {}}
            onNext={() => {}}
            showEditButton
            onEdit={() => alert('Edit metadata clicked!')}
            showDeleteButton
            onDelete={() => alert('Delete business type clicked!')}
            websiteObjectives={['Increase online sales conversion', 'Improve customer retention']}
            industryPainpoints={['Cart abandonment', 'Shipping cost concerns']}
          />
        </div>
        <p className={styles.hint}>
          Hover over the chip to see the popover. Click edit to modify metadata.
        </p>
      </div>
    </section>
  );
};
